import { inject } from 'aurelia-framework';
import { HttpClient } from 'aurelia-fetch-client';
import download from 'downloadjs';
import moment from 'moment';

@inject(HttpClient)
export class ExportService {
  constructor(http) {
    this.http = http;
  }

  async exportRawMaterials() {
    const response = await this.http.fetch('export/raw-materials');
    const blob = await response.blob();
    download(blob, `RawMaterials-${moment().format('L')}.csv`, "text/csv");
  }

  async exportProcessRecords(workCenter, processId, machineId) {
    const response = await this.http.fetch(`export/process-records/${workCenter}/${processId}/${machineId}`);
    const blob = await response.blob();
    download(blob, `ProcessRecords-${moment().format('L')}.csv`, "text/csv");
  }
  
  async exportOverriddenProcessRecords(workCenter, processId, machineId) {
    const response = await this.http.fetch(`export/overridden-process-records/${workCenter}/${processId}/${machineId}`);
    const blob = await response.blob();
    download(blob, `OverriddenProcessRecords-${moment().format('L')}.csv`, "text/csv");
  }

  async exportPurchasePartRecords() {
    const response = await this.http.fetch('export/purchase-part-records');
    const blob = await response.blob();
    download(blob, `PurchasePartRecords-${moment().format('L')}.csv`, "text/csv");
  }

  async exportScrapOverride() {
    const response = await this.http.fetch('export/scrap-override');
    const blob = await response.blob();
    download(blob, `ScrapOverride-${moment().format('L')}.csv`, 'text/csv');
  }
}
